export const matchedstatusOptions = [
  { label: "To Confirm", value: "To Confirm" },
  { label: "Further Action", value: "Further Action" },
  { label: "Error", value: "Error" },
  { label: "Matched", value: "Matched" },
  { label: "Ready to Export", value: "Ready to Export" },
  { label: "Exported", value: "Exported" },
];

export const matchedFlagOptions = [
  { label: "TOL", value: "TOL" },
  { label: "BRF", value: "BRF" },
  { label: "CST", value: "CST" },
  { label: "ESP", value: "ESP" },
  { label: "SIR", value: "SIR" },
  { label: "GRP", value: "GRP" },
  { label: "OTH", value: "OTH" },
  { label: "REJ", value: "REJ" },
  { label: "UNM", value: "UNM" },
];

export const matchedTeamOptions = [
  { label: "PRO", value: "PRO" },
  { label: "RES", value: "RES" },
  { label: "OCS", value: "OCS" },
  { label: "FIN", value: "FIN" },
  { label: "LDG", value: "LDG" },
  { label: "FLI", value: "FLI" },
  { label: "EV", value: "EV" },
];

export const espWorkflowTeamOptions = matchedTeamOptions;

export enum MatchedStatusEnum {
  TO_CONFIRM = "To Confirm",
  FURTHER_ACTION = "Further Action",
  ERROR = "Error",
  MATCHED = "Matched",
  READY_TO_EXPORT = "Ready to Export",
  EXPORTED = "Exported",
  COMPLETED = "Completed",
}

export enum EspWorkflowStatusEnum {
  EXPORTED = "Exported",
  COMPLETED = "Completed",
  UNMATCHED = "Unmatched",
}

export enum APWorkflowStatusTab {
  REVIEW = "review",
  MATCHED = "matched",
  READY_TO_EXPORT = "ready_to_export",
  EXPORTED = "exported",
  COMPLETED = "completed",
}

export const APWorkflowStatusOptions = [
  { label: "To Confirm", value: "To Confirm" },
  { label: "Further Action", value: "Further Action" },
  { label: "Error", value: "Error" },
  { label: "Matched", value: "Matched" },
];

export const filterStatusTabReviewOptions = [
  { label: "To Confirm", value: "To Confirm" },
  { label: "Further Action", value: "Further Action" },
  { label: "Error", value: "Error" },
];

export const filterStatusTabMatchedOptions = [{ label: "Matched", value: "Matched" }];
export const filterStatusTabCompletedOptions = [{ label: "Completed", value: "Completed" }];
